module.exports = __webpack_public_path__ + "static/media/W77F1013.c051f2b6.svg";